export function notFound(status: number) {
    return status === 404;
}

export function serverError(status: number) {
    return status >= 500 && status <= 599;
}
